import { createFileRoute } from "@tanstack/react-router";

import { LogsContent } from "@/features/dashboard/logs/components/LogsContent";

export const Route = createFileRoute("/_private/dashboard/_base/logs/$id/")({
  component: LogsContent
});
